/** Brand wordmark: the Campus mark plus "Eryce" set in Mona Sans (styled by `.wordmark`). */
export function Wordmark() {
  return (
    <>
      <svg className="logo" viewBox="0 0 24 24" aria-hidden focusable="false">
        <path d="M0 0h6v24h-6z M9 0h15v6h-15z M9 18h15v6h-15z" fill="currentColor" />
        <path d="M9 9h9v6h-9z" className="logo-accent-fill" />
      </svg>
      Eryce
    </>
  );
}
